import type { EstimateStatus } from '@/types/estimate';
import type { DataTableNumberOperator } from '@/components/molecules';

export interface EstimateListFilters {
  /** Toolbar search box — matched against number, title, customer name/email/phone. */
  q: string;
  status: EstimateStatus | 'all';
  estimateNumber: string;
  customerName: string;
  totalOp: DataTableNumberOperator;
  totalValue: string;
  updatedFrom: string | undefined;
  updatedTo: string | undefined;
  serviceAddress: string;
  customerEmail: string;
  customerPhone: string;
  salespersonId?: string;
  businessUnitId?: string;
  page: number;
  sort: number;
  dateFrom: string | undefined;
  dateTo: string | undefined;
  tagId: string | undefined;
}

export const DEFAULT_ESTIMATE_LIST_FILTERS: EstimateListFilters = {
  q: '',
  status: 'all',
  estimateNumber: '',
  customerName: '',
  totalOp: 'eq',
  totalValue: '',
  updatedFrom: undefined,
  updatedTo: undefined,
  serviceAddress: '',
  customerEmail: '',
  customerPhone: '',
  salespersonId: undefined,
  businessUnitId: undefined,
  page: 1,
  sort: 0,
  dateFrom: undefined,
  dateTo: undefined,
  tagId: undefined,
};
